import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const GroceryV2Header = ({ 
    newItem, 
    setNewItem, 
    handleAddItem, 
    newCategory, 
    setNewCategory, 
    handleAddCategory,
    handleDeleteCheckedItems,
    checkedItemsCount,
    editMode,
    handleRefresh,
    handleUndo,
    undoListLength
}) => {
    return (
        <div className={'flex flex-col w-full md:w-2/3 mx-auto'}>
            <div className={'flex flex-col w-full space-y-2 mb-2'}>
                {/* Mobile only: buttons row */}
                <div className="flex md:hidden flex-row justify-between gap-2 w-full">
                    <div className="flex flex-row gap-2">
                        <button
                            title={'Refresh List'}
                            onClick={handleRefresh}
                            type={'button'}
                            className={'bg-white border-black border-2 text-black p-2 rounded-md hover:bg-zinc-300'}>
                            <FontAwesomeIcon icon="fas fa-refresh"/> <span className="ml-1">Refresh</span>
                        </button>
                        <button
                            title={'Undo Action'}
                            onClick={handleUndo}
                            type={'button'}
                            className={`${undoListLength > 0 ? "bg-white" : "bg-zinc-500"} border-black border-2 text-black p-2 rounded-md hover:bg-zinc-300`}>
                            <FontAwesomeIcon icon="fas fa-undo"/> <span className="ml-1">Undo</span>
                        </button>
                    </div>

                    {editMode && (
                        <div className="flex flex-row gap-2">
                            <button
                                onClick={handleDeleteCheckedItems}
                                type={'button'}
                                title="Delete Checked Items"
                                disabled={checkedItemsCount === 0}
                                className={`${checkedItemsCount > 0 ? 'bg-red-500 hover:bg-red-300' : 'bg-zinc-500'} text-white p-2 border-black border-2 rounded-md`}>
                                <FontAwesomeIcon icon="fas fa-check"/> Delete Checked ({checkedItemsCount})
                            </button>
                        </div>
                    )}
                </div>

                {/* Desktop: Add Item Form */}
                <form onSubmit={(e) => { e.preventDefault(); handleAddItem(); }} className={'hidden md:flex flex-row w-full gap-2'}>
                    <button
                        title={'Refresh List'}
                        onClick={handleRefresh}
                        type={'button'}
                        className={'bg-white border-black border-2 text-black p-2 rounded-md hover:bg-zinc-300 w-10'}>
                        <FontAwesomeIcon icon="fas fa-refresh"/>
                    </button>
                    <button
                        title={'Undo Action'}
                        onClick={handleUndo}
                        type={'button'}
                        className={`${undoListLength > 0 ? "bg-white" : "bg-zinc-500"} border-black border-2 text-black p-2 rounded-md hover:bg-zinc-300 w-10`}>
                        <FontAwesomeIcon icon="fas fa-undo"/>
                    </button>
                    <input
                        value={newItem}
                        onChange={(e) => setNewItem(e.target.value)}
                        type="text"
                        placeholder="Add new item..."
                        className="bg-white border-black border-2 text-black p-2 text-md flex-grow rounded-md"
                    />
                    <button
                        type="submit"
                        className="bg-blue-500 border-black border-2 text-white p-2 rounded-md hover:bg-blue-300 whitespace-nowrap">
                        Add Item
                    </button>
                    {editMode && (
                        <button
                            onClick={handleDeleteCheckedItems}
                            type={'button'}
                            title="Delete Checked Items"
                            disabled={checkedItemsCount === 0}
                            className={`${checkedItemsCount > 0 ? 'bg-red-500 hover:bg-red-300' : 'bg-zinc-500'} text-white p-2 border-black border-2 rounded-md whitespace-nowrap`}>
                            <FontAwesomeIcon icon="fas fa-check"/> Delete Checked ({checkedItemsCount})
                        </button>
                    )}
                </form>

                {/* Mobile: Add Item Form */}
                <form onSubmit={(e) => { e.preventDefault(); handleAddItem(); }} className={'flex md:hidden flex-row w-full gap-2'}>
                    <input
                        value={newItem}
                        onChange={(e) => setNewItem(e.target.value)}
                        type="text"
                        placeholder="Add new item..."
                        className="bg-white border-black border-2 text-black p-2 text-md flex-grow rounded-md"
                    />
                    <button
                        type="submit"
                        className="bg-blue-500 border-black border-2 text-white p-2 rounded-md hover:bg-blue-300">
                        Add
                    </button>
                </form>

                {/* Category Form - only show in edit mode */}
                {editMode && (
                    <form onSubmit={(e) => { e.preventDefault(); handleAddCategory(); }} className={'flex flex-row w-full gap-2'}>
                        <input
                            value={newCategory}
                            onChange={(e) => setNewCategory(e.target.value)}
                            type="text"
                            placeholder="Add new category..."
                            className="bg-white border-black border-2 text-black p-2 text-md flex-grow rounded-md"
                        />
                        <button
                            type="submit"
                            className="bg-green-500 border-black border-2 text-white p-2 rounded-md hover:bg-green-300 whitespace-nowrap">
                            Add Category
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default GroceryV2Header;
